<template>
  <div :class="[languagezh_cn ? '' : 'myCss']">
    <!-- <el-emp-footer
      :helpData="helpData"
      :qrCode="qrCode"
      :isShowCopyright="isShowCopyright"
      :serviceItemData="serviceItemData"
      :Wx="$t('page.content.officialWeChat')"
      :copyRighta="$t('page.content.Copyright1')"
      :divider="$t('page.content.divider')"
      :copyRightb="$t('page.content.statement1')"
    /> -->

    <div class="el-emp-footer">
      <div class="service ">
        <div class="wrapper">
          <ul class="service-list">
            <li class="service-item">
              <div class="service-unit">
                <i class="icon-ccui-sharing-o" />
                <p class="service-txt">{{ serviceItemData[0] }}</p>
              </div>
            </li>
            <li class="service-item">
              <div class="service-unit">
                <i class="icon-ccui-high-quality-service" />
                <p class="service-txt">{{ serviceItemData[1] }}</p>
              </div>
            </li>
            <li class="service-item">
              <div class="service-unit">
                <i class="icon-ccui-star-o" />
                <p class="service-txt">{{ serviceItemData[2] }}</p>
              </div>
            </li>
            <li class="service-item">
              <div class="service-unit">
                <i class="icon-ccui-rmb-o" />
                <p class="service-txt">{{ serviceItemData[3] }}</p>
              </div>
            </li>
            <li class="service-item">
              <div class="service-unit">
                <i class="icon-ccui-promote-o" />
                <p class="service-txt">{{ serviceItemData[4] }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="divider"></div>
      <div class="help">
        <div class="wrapper">
          <div class="help-list">
            <div
              class="help-nav"
              v-for="(item, index) in helpData"
              :key="index"
            >
              <div>
                <h5 class="help-nav-tit">{{ item.tit }}</h5>
                <ul class="help-nav-con">
                  <li v-for="(con, i) in item.list" :key="i">
                    <p v-if="!con.url" style="cursor: default;">
                      {{ con.label }}
                    </p>
                    <div
                      v-if="con.url"
                      style="cursor: pointer;"
                      @click="targetUrl(con)"
                    >
                      {{ con.label }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="help-nav">
              <div class="help-nav-con qrcode-wrapper">
                <div class="qrcode">
                  <img :src="qrCode" alt="" />
                </div>
                <div class="tit">官方微信</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="isShowCopyright">
        <div class="divider second"></div>
        <div class="copy-right-wrapper">
          <div class="copy-right">
            <div>{{ $t("page.content.Copyright1") }}</div>
            <div class="h-divider"></div>
            <!-- <p>
            {{$t('page.content.divider')}}：<a
              href="https://beian.miit.gov.cn/"
              style="color: inherit;"
              target="_blank"
              >闽ICP备2022005227号-2</a
            >
            中交电商
          </p> -->
            <p>
              {{ $t("page.content.divider")
              }}<a
                href="https://beian.miit.gov.cn/"
                style="color: inherit;"
                target="_blank"
                >{{ $t("page.content.statement1") }}</a
              >
            </p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      qrCode: require("@/basa/assets/images/code.jpg"),
      isShowCopyright: true,
      serviceItemData: [
        this.$t("page.content.resourceSharing"),
        this.$t("page.content.qualityService"),
        this.$t("page.content.legalCompliance"),
        this.$t("page.content.reduceCostsAndincrease"),
        this.$t("page.content.managementPromotion")
      ],
      helpData: [
        {
          tit: this.$t("page.content.aboutUs"),
          list: [
            { label: this.$t("page.content.introPlatform"), url: "" },
            {
              label: this.$t("page.content.contactUs"),
              url: ""
            },
            {
              label: this.$t("page.content.relevantPoliciesAndRegulations"),
              url: ""
            }
          ]
        },
        {
          tit: this.$t("page.content.purchaser"),
          list: [
            {
              label: this.$t("page.content.operationGuide"),
              url: "https://ahca.iccec.cn/index"
            },
            { label: this.$t("page.content.videoTutorial"), url: "" }
          ]
        },
        {
          tit: this.$t("page.content.Partners"),
          list: [
            {
              label: this.$t("page.content.operationGuide"),
              url:
                "https://sp.iccec.cn/operationManual?isJRZL=1&searchType=首页"
            },
            { label: this.$t("page.content.videoTutorial"), url: "" },
            {
              label: this.$t("page.content.netInformation"),
              url:
                "https://sp.iccec.cn/infoManageNetworkAccess?isJRZL=1&searchType=首页"
            }
          ]
        },
        {
          tit: this.$t("page.content.commonProblem"),
          list: [
            {
              label: this.$t("page.content.purchaseCommonProblem"),
              url: "https://ahca.iccec.cn/purchaser-faq"
            },
            {
              label: this.$t("page.content.PartnersCommonProblem"),
              url: "https://sp.iccec.cn/question?isJRZL=1&searchType=首页"
            }
          ]
        },
        {
          tit: this.$t("page.content.serviceCenter"),
          list: [
            {
              label: this.$t("page.content.onlineCounsel"),
              url: "https://work.weixin.qq.com/kfid/kfca8000d191a60882f"
            },
            { label: this.$t("page.content.afterSalesService"), url: "" },
            {
              label: this.$t("page.content.feedback"),
              url:
                "https://moa.iccec.cn/user-feedback/user-feedback-list/list?a=100112&CODE=75617927d0554808ac4edf9c69a5556e"
            },
            { label: this.$t("page.content.fileTemplateDownload"), url: "" }
          ]
        },
        {
          tit: this.$t("page.content.supplyChainFinanceCenter"),
          list: [
            { label: this.$t("page.content.operationGuide"), url: "" },
            { label: this.$t("page.content.commonProblem"), url: "" }
          ]
        }
      ]
    };
  },
  computed: {
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    }
  },
  mounted() {},
  methods: {
    search(kw) {
      console.log(kw);
    },
    targetUrl(row) {
      if (row.url) {
        window.open(row.url, "_blank");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.el-emp-footer .help .wrapper .help-list .help-nav .help-nav-con li div {
  height: 27px;
  font-size: 12px;
  font-weight: 400;
  color: #666;
  line-height: 27px;
  &:hover {
    color: #0089ef !important;
  }
}
.myCss {
  /deep/ .el-emp-footer .service .wrapper .service-list {
    height: 110px !important;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
  }
  /deep/
    .el-emp-footer
    .service
    .wrapper
    .service-list
    .service-item:nth-child(2) {
    margin-left: 222px;
  }
  /deep/
    .el-emp-footer
    .service
    .wrapper
    .service-list
    .service-item:nth-child(5) {
    margin-left: 356px;
  }
  /deep/
    .el-emp-footer
    .service
    .wrapper
    .service-list
    .service-item
    .service-unit {
    padding-top: 10px;
  }
  /deep/ .el-emp-footer .help .wrapper .help-list .help-nav .help-nav-con li p {
    height: 50px;
  }
  /deep/ .help-nav-tit {
    margin-bottom: 22px !important;
  }
  /deep/ .help-nav-con > li > p {
    line-height: 19px !important;
  }
  /deep/ .service-list li:nth-child(4) {
    margin-left: 0px !important;
  }

  .el-emp-footer .help .wrapper .help-list .help-nav .help-nav-con li div {
    height: 50px;
  }
}
</style>
